import { memo } from 'react';

import classNames from 'classnames';

import useStyles from './styles';

import type { SkeletonType } from './types';

function Skeleton({ height, className }: SkeletonType) {
  const { root } = useStyles({ height });

  return <i className={classNames(root, className)} />;
}

export default memo(Skeleton);
